import { createSelector } from 'reselect';
import { actionKey } from './constants';
function getSlice(state) {
    return state[actionKey] || {
        fileUploads: [],
        fileUploadsWaiting: [],
        fileUploadsCompleted: [],
        documentUploads: {}
    };
}
export const getUploads = createSelector(getSlice, (slice)=>slice.fileUploads);
export const getUploadsWaiting = createSelector(getSlice, (slice)=>slice.fileUploadsWaiting);
export const getAllUploads = createSelector(getUploads, getUploadsWaiting, (uploads, uploadsWaiting)=>[
        ...uploads,
        ...uploadsWaiting
    ]);
export const getCompletedUploads = createSelector(getSlice, (slice)=>slice.fileUploadsCompleted);
export const getUploadById = createSelector(getAllUploads, (state, uploadId)=>uploadId, (allUploads, uploadId)=>allUploads.find((fu)=>fu.uploadId === uploadId));
export const getUploadsByTag = createSelector(getAllUploads, (state, tag)=>tag, (allUploads, tag)=>allUploads.filter((fu)=>fu.tag === tag));
export const getAttachmentUploads = createSelector(getSlice, (slice)=>slice.attachmentUploads);
export const getAttachmentUploadsWaiting = createSelector(getSlice, (slice)=>slice.attachmentUploadsWaiting);
export const getAllAttachmentUploads = createSelector(getAttachmentUploads, getAttachmentUploadsWaiting, (attachmentUploads, attachmentUploadsWaiting)=>[
        ...attachmentUploads,
        ...attachmentUploadsWaiting
    ]);
export const getAttachmentUploadsByTag = createSelector(getAllAttachmentUploads, (state, tag)=>tag, (attachmentUploads, tag)=>attachmentUploads.filter((fu)=>fu.tag === tag));
export const getDocumentUploads = createSelector(getSlice, (slice)=>slice.documentUploads);
export const getDocumentUploadByType = createSelector(getDocumentUploads, (state, documentType)=>documentType, (documentUploads, documentType)=>documentUploads[documentType]);
export const getAllAttachmentDeviationLockStatuses = createSelector(getSlice, (slice)=>slice.attachmentDeviationLocked);
export const getIsAttachmentDeviationLocked = createSelector(getAllAttachmentDeviationLockStatuses, (state, deviationId)=>deviationId, (slice, deviationId)=>(slice === null || slice === void 0 ? void 0 : slice[deviationId]) === true);

//# sourceMappingURL=selectors.js.map